import { render, staticRenderFns } from "./lackPackagesDetails.vue?vue&type=template&id=950e2bca&scoped=true&"
import script from "./lackPackagesDetails.vue?vue&type=script&lang=js&"
export * from "./lackPackagesDetails.vue?vue&type=script&lang=js&"
import style0 from "./lackPackagesDetails.vue?vue&type=style&index=0&id=950e2bca&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950e2bca",
  null
  
)

export default component.exports